// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"be10109c","container":"cf8d0fca"};